<template>
  <slotted-edit-list-item :label="label"
                          :keyname="keyname"
                          :value="value"
                          :edit="edit"
                          :onlyedit="onlyedit"
                          :loading="loading">

    <template v-slot:editmodecontent>
      <normal-mode-template :label="label"
                            :value="editValue"
                            :loading="loading">
        <template v-slot:value>
          <v-slider v-model="editValue"
                    thumb-label
                    dense
                    hide-details
                    track-color="disabled"
                    :min="min"
                    :max="max"
                    :thumb-size="28"
                    class="mx-2 mt-3">
          </v-slider>
        </template>
      </normal-mode-template>
    </template>

  </slotted-edit-list-item>
</template>


<script>
import SlottedEditListItem from "@/components/Inputs/Parts/SlottedEditListItem.vue";
import NormalModeTemplate from "@/components/Inputs/Parts/NormalModeTemplate.vue";

export default {
  name: "SliderEditListItem",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    label: String,
    keyname: String,
    value: Number,
    min: Number,
    max: Number,
    edit: Boolean,
    onlyedit: Boolean,
    loading: Boolean,
  },
  components: { SlottedEditListItem, NormalModeTemplate },

  data() {
    return { editValue: null };
  },

  mounted() {
    this.getValue();
  },

  methods: {
    getValue() {
      this.editValue = this.value;
    },
  },

  computed: {},

  watch: {
    editValue: function () {
      this.$emit("change", this.editValue);
      this.$emit("fetch", { key: this.keyname, value: this.editValue });
    },

    value: function () {
      this.getValue();
    },

    edit: function () {
      if (this.edit) {
        this.getValue();
      }
    },
  },
};
</script>

<style scoped>
</style>